/**
 * @ngdoc directive
 * @name ng.directive:ngPopChrome
 * @element ANY
 * @function Pop Interstitial chrome directive
 */

const ngPopChrome = ['$cookies', '$device', '$http', function ($cookies, $device, $http) {
    return {
        link: ( $scope, $item, $params ) => {
            // Only for chrome
            if ( $scope.device.browser.chrome === false ) {
                return false;
            }

            // If we have a pop available
            // if ( $params.ngPopChrome.trim().length === 0 ) {
            //     return false;
            // }
            // Remove href contents and clone it as data attribute

            let $_loaded = false;
            let $_target = $item[0].href;
            let $_channel_id = $params.ngPopChrome;

            $scope.$watchCollection('service', ( $service ) => {
                if ( $service.ready === true && $service.pop_under !== null && $_loaded === false ) {
                    $_loaded = true;

                    // && $service.pop_under.


                    console.log("Loaded " + $params.ngPopChrome);

                    $item[0].removeAttribute("href");

                    let $timer = 0;
                    let handler = ('ontouchstart' in document.documentElement ? "touchstart" : "click");
                    let timeout = ('ontouchstart' in document.documentElement ? 500 : 0);
                    let $_device = $scope.device.mobile ? 'mobile' : 'desktop';

                    let $_record = $scope.service.pop_under.channels.hasOwnProperty($params.ngPopChrome) ? $scope.service.pop_under.channels[$params.ngPopChrome] : null;
                    let $_iframe = $scope.service.pop_under.iframe;

                    $item[0].addEventListener ( handler, () => {
                        clearTimeout($timer);
                        $timer = setTimeout(function () {
                            $scope.pop_under = $_record;
                            $http.get('/service/dismiss?dismiss=pop-under');
                            $scope.chromeInterstitialHref = $_target;
                            $scope.chromeInterstitialFrame = !$_record ? $_iframe : null;
                            $scope.modules.display.chrome = true;
                            $scope.$apply();

                            $scope.chromeFrameSubmit = () => {
                                setTimeout(() => {
                                    document.querySelector('[name="chrome-form"]').submit();
                                }, 100 );
                            }

                        }, timeout );
                    }, {passive: true});

                    // Disable action for swipe
                    $item[0].addEventListener('touchmove', () => {
                         clearTimeout($timer);
                    }, { passive: true });
                }
            });
        }
    }
}];

export default ngPopChrome;
